import React from "react";
import { useTranslation } from "react-i18next";
import { DepositAgreementStatus } from "features/payments/enums/depositAgreementStatus";

interface Props {
  status: DepositAgreementStatus;
}

const badgeByStatus: Record<DepositAgreementStatus, string> = {
  Active:     "badge-info",
  Paid:    "badge-success",
  Settled:  "badge-warning",
  Cancelled:  "badge-danger",
};

const DepositAgreementStatusLabel = ({ status }: Props) => {
  const { t } = useTranslation(["depositAgreement\\enums\\depositAgreementStatus"]);
  const badgeClass = badgeByStatus[status] ?? "badge-light";

  return (
    <span className={`badge badge-pill ${badgeClass} small font-weight-normal`}>
      {t(status)}
    </span>
  );
};

export default DepositAgreementStatusLabel;
